<template>
    <div>
        <h2
            v-if="title"
            class="typo-h4 mb-3 mt-0"
        >
            {{ title }}
        </h2>
        <p
            v-if="description || descriptionLink"
            class="typo-body-1 mb-10 mt-0"
        >
            {{ description }}

            <router-link
                v-if="descriptionLink"
                :to="descriptionLink.route"
                class="typo-h6"
                :class="[`color-${color}-text`]"
            >
                {{ descriptionLink.title }}
            </router-link>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'FormTitle',

        props: {
            /**
             * Color of the links, buttons and forms
             */
            color: String,

            /**
             * Form Title, shows at the top of the form
             * Accepts html string
             * Used Types: Modern
             */
            title: String,

            /**
             * Form Description, shows at the bottom of the form title
             * Used Types: Modern
             */
            description: String,

            /**
             * Form Description Link, shows at the end of the form description
             * Used Types: Modern
             * Sample: {
             * `    title: '',
             * `    route: {
             * `        name: '', params: {}, query: {},
             * `    }
             * `}
             * }
             */
            descriptionLink: Object,
        },
    };
</script>
